import { isValidApiBaseProps } from '@common/api.services';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { IDesignBriefSearch } from '@designBrief/designBrief.models';
import { IProjectDesignModificationSearchResult } from '@designModification/designModification.models';
import { IPagedResultsV1 } from '@gcl/react-core';
import { ILoadingRemovalCertSearch } from '@permitToLoadRemove/permitToLoadRemove.models';
import { useQuery } from '@tanstack/react-query';
import { ITransmittalItem } from '@transmittal/transmittal.models';
import { AxiosErrorResponse } from '@core/error.models';
import { IProjectCertificateSearchResult } from 'src/projectCertificate/projectCertificate.models';
import { IByT1Request } from './DetailPageRightMenu.models';
import {
  getCheckCertificatesByT1Async,
  getCheckerTransmittalsByT1Async,
  getDesignBriefsByT1Async,
  getDesignerTransmittalsByT1Async,
  getDesignModificationsByT1Async,
  getLoadingRemovalCertsByT1Async,
  getReviewerTransmittalsByT1Async,
  getSiteTransmittalsByT1Async,
} from './DetailPageRightMenu.services';

export const createFetchByT1Fn = <T>(
  queryName: string,
  fetchFn: (params: IByT1Request) => Promise<IPagedResultsV1<T>>,
) => {
  return (props: IByT1Request, enabled = true) => {
    return useQuery<T[] | undefined, AxiosErrorResponse>(
      [props.projectId, props.projectMasterScheduleId, queryName],
      async () => {
        const results = await fetchFn(props);
        return results.items;
      },
      {
        enabled: !!props.projectMasterScheduleId && isValidApiBaseProps(props) && enabled,
      },
    );
  };
};

export const useFetchDesignBriefsByT1 = createFetchByT1Fn<IDesignBriefSearch>(
  FETCH_QUERIES_NAME.DESIGN_BRIEF_BY_T1,
  getDesignBriefsByT1Async,
);
export const useFetchDesignModificationsByT1 = createFetchByT1Fn<IProjectDesignModificationSearchResult>(
  FETCH_QUERIES_NAME.DESIGN_MODIFICATION_BY_T1,
  getDesignModificationsByT1Async,
);
export const useFetchLoadingRemovalCertsByT1 = createFetchByT1Fn<ILoadingRemovalCertSearch>(
  FETCH_QUERIES_NAME.LOADING_REMOVAL_CERT_BY_T1,
  getLoadingRemovalCertsByT1Async,
);
export const useFetchDesignerTransmittalsByT1 = createFetchByT1Fn<ITransmittalItem>(
  FETCH_QUERIES_NAME.DESIGNER_TRANSMITTAL_BY_T1,
  getDesignerTransmittalsByT1Async,
);
export const useFetchCheckerTransmittalsByT1 = createFetchByT1Fn<ITransmittalItem>(
  FETCH_QUERIES_NAME.CHECKER_TRANSMITTAL_BY_T1,
  getCheckerTransmittalsByT1Async,
);
export const useFetchSiteTransmittalsByT1 = createFetchByT1Fn<ITransmittalItem>(
  FETCH_QUERIES_NAME.SITE_TRANSMITTAL_BY_T1,
  getSiteTransmittalsByT1Async,
);
export const useFetchReviewerTransmittalsByT1 = createFetchByT1Fn<ITransmittalItem>(
  FETCH_QUERIES_NAME.REVIEWER_TRANSMITTAL_BY_T1,
  getReviewerTransmittalsByT1Async,
);
export const useFetchCheckCertificatesByT1 = createFetchByT1Fn<IProjectCertificateSearchResult>(
  FETCH_QUERIES_NAME.CHECK_CERTIFICATES_BY_T1,
  getCheckCertificatesByT1Async,
);
